import React from 'react'
import { SwatchesPicker } from 'react-color'
import startCase from 'lodash/startCase'

export default class CalendarKey extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      displayColorPicker: false,
    }

    this.toggleColorPicker = this.toggleColorPicker.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose () {
    this.setState({ displayColorPicker: false })
  }
  
  toggleColorPicker () {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  render () {
    const { keyName, onChangeComplete, color } = this.props

    const colorPickerStyle = {
      // position: 'relative',
      // display: 'inline-block',
      position: 'absolute',
      zIndex: '5000',
      bottom: '10%',
    }

    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }

    return (
        <li style={{ flex: '1', fontWeight: 'bold', display: 'flex', justifyContent: 'center' }} key={keyName}>
          <span onClick={this.toggleColorPicker}  style={{ fontSize: '35px', color, alignSelf: 'center' }}>•</span>
          <span style={{ alignSelf: 'center', fontSize: '15px', paddingLeft: '5px' }}>{startCase(keyName)}</span>
          {
            this.state.displayColorPicker &&
              <div style={colorPickerStyle}>
                <div style={ cover } onClick={ this.handleClose }/>
                <SwatchesPicker
                  triangle="hide"
                  onChangeComplete={
                    (color) => {
                      onChangeComplete(keyName)(color)
                      this.toggleColorPicker()
                    }
                  }
                />
              </div>
          }
        </li>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/calendar/calendar-key.js